import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React from 'react';
export var Button = function Button(_ref) {
  var _cx;

  var children = _ref.children,
      className = _ref.className,
      height = _ref.height,
      variant = _ref.variant,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["children", "className", "height", "variant", "width"]);

  return React.createElement("button", _objectSpread({
    className: cx('tds-btn', (_cx = {}, _defineProperty(_cx, "tds-btn--".concat(height), height), _defineProperty(_cx, "tds-btn--".concat(variant), variant), _defineProperty(_cx, "tds-btn--width-".concat(width), width), _cx), className)
  }, rest), children);
};